import React from "react";
import { RecognizePersons } from "../components/Person Recognition/recognition";

export const PersonSearch = () => {
  return (
    <RecognizePersons />
  );
};
